<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 mt-4 mb-5">
                <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                        <div class="counceltitle__flex">
                            <div>
                                <button class="create" (click)="pending()">create</button>
                            </div>
                        </div>
                        <!-- <div class="border-line"></div> -->
                        <div class="ibox-content">
                            <mat-card>
                                <ng-container *ngIf="dataAvailable; else noData">
                                    <!--- no data-->
                                    <div class="searchpaginator">
                                        <div class="table_search">
                                            <input type="text" class="form-control" (keyup)="applyFilter($event)"
                                                placeholder="Search">
                                        </div>
                                        <div>
                                            <mat-paginator [pageSize]="10"
                                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                        </div>
                                        <!-- <span (click)="exportAsXLSX()"><img src="../../assets/image/vscode-icons_file-type-excel.svg" class="excel_sheet" alt=""></span> -->
                                    </div>
                                    <div class="table-responsive">
                                        <mat-card-content>
                                            <table mat-table [dataSource]="assetvehiclelist" matSort>

                                                <ng-container matColumnDef="orcFusionBuildingCode">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Bld Fusion
                                                        Code
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;">
                                                        {{row.orcFusionBuildingCode}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="buildingName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Building Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.buildingName}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="orgName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Entity </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.orgName}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="minorCategoryName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Category Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.minorCategoryName}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="vehicleNumber">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>vehicle Number
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.vehicleNumber}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="approveStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.approveStatus}} </td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="displayedColumns  sticky: true">
                                                </tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                                <tr class="mat-row" *matNoDataRow>
                                                    <td class="mat-cell" class="not_matchdata" colspan="6">No data
                                                        matching the filter
                                                    </td>
                                                </tr>
                                            </table>
                                        </mat-card-content>
                                    </div>
                                </ng-container>
                            </mat-card>

                            <ng-template #noData>
                                <section class="section_one">
                                    <div class="cctvcouncelling__sec">
                                        <div class="councellist__flex">
                                            <div>
                                                <div class="nodata_center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../assets/image/nodata.png" alt="nodata"
                                                            class="nodata">
                                                    </figure>
                                                    <p class="no_data">No Data Found</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<!-- =======Loading ========== -->

<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner> -->